import { NavLink, generatePath, useMatch, useParams } from 'react-router-dom';
import { PermissionEnum, Table } from '@ui/src';
import { useAppSelector } from '@store';
import Card from '../../../../components/common/card/card';
import { CustomerStatus } from '../../../common/types';
import { overviewCompaniesColumns } from '../variables/overview-companies';
import { OverviewCompaniesTypes } from '../types';
import useOverviewCompanies from '../hooks/use-companies';

import ROUTES from '../../../../routes';

import cn from '../styles.module.css';
import cardStyles from '../../../../components/common/card/card.module.css';

const OverviewCompanies = ({
  isLoading,
  status,
}: OverviewCompaniesTypes): React.JSX.Element => {
  const { customerId } = useParams();

  const { activePermissions } = useAppSelector((state) => state.root);

  const {
    sort,
    onSortChange,
    onFilterChange,
    filters,
    selectedTab,
    setSelectedTab,
    selectedCompanies,
  } = useOverviewCompanies();

  const transactionsMatch = useMatch(
    generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS, {
      customerId: customerId as string,
    }),
  );

  let companiesPath = generatePath(
    ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS_COMPANIES,
    { customerId: customerId as string },
  );

  if (transactionsMatch) {
    companiesPath = generatePath(
      ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES,
      { customerId: customerId as string },
    );
  }

  return (
    <div>
      <div className={cn.companiesTitle}>
        <div className={cn.companiesTitleText}>Companies</div>
        {activePermissions?.includes(
          PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION,
        ) &&
          status !== CustomerStatus.CLOSED && (
            <NavLink to={companiesPath} className={cn.companiesTitleLink}>
              Edit
            </NavLink>
          )}
      </div>
      <div className={cn.companyOfficialTabs}>
        <button
          type="button"
          className={`${cn.companyOfficialTab} ${
            selectedTab === 'current' ? cn.companyOfficialTabActive : ''
          }`}
          onClick={() => setSelectedTab('current')}
        >
          Current
        </button>
        <button
          type="button"
          className={`${cn.companyOfficialTab} ${
            selectedTab === 'removed' ? cn.companyOfficialTabActive : ''
          }`}
          onClick={() => setSelectedTab('removed')}
        >
          Removed
        </button>
      </div>

      <Card
        isLoading={isLoading}
        className={`${cardStyles.overviewCompaniesCard} ${cn.overviewCompaniesCard}`}
      >
        <Table
          columns={overviewCompaniesColumns}
          data={selectedCompanies || []}
          onSort={(name) => onSortChange(name)}
          filters={filters}
          sort={sort}
          columnsLabels={{}}
          onFilterChange={onFilterChange}
          isLoading={isLoading}
          tableFormClassName={cn.overviewCompaniesTableForm}
          tableHeadCellClassName={cn.overviewCompaniesTableHeadCell}
          tableBodyClassName={
            !selectedCompanies?.length ? cn.overviewCompaniesTableBody : ''
          }
          clickable
        />
      </Card>
    </div>
  );
};

export default OverviewCompanies;
